import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { WeezHeader, Button, Card, Form, Message, Select, TooltipHelp, Icon, ToastContext } from '@weezevent/nacre';
import SwornStatement from './swornStatement';
import { useForm } from '@weezevent/weezjs-core';
import Conditional, { requiredField } from '../../utils/validators';
import MessageInformation from './messageInformation';
import BankModel from '../../models/bank';
import ImgChequeCAD from './images/cheque_CAD.jpg';
import Style from './bank.module.css';
import MessageValidationBank from './messageValidationBank';
import LoadingCard from '../../components/loadingCard';

const institutionsCanadian = [
    { value: '1', text: '001 - Bank of Montreal' },
    { value: '2', text: '002 - Bank of Nova Scotia' },
    { value: '3', text: '003 - Royal Bank of Canada' },
    { value: '4', text: '004 - Toronto-Dominion Bank' },
    { value: '6', text: '006 - National Bank of Canada' },
    { value: '10', text: '010 - Canadian Imperial Bank of Commerce' },
    { value: '16', text: '016 - HSBC Canada' },
    { value: '30', text: '030 - Canadian Western Bank' },
    { value: '39', text: '039 - Laurentian Bank of Canada' },
    { value: '127', text: '127 - Canada Post' },
    { value: '177', text: '177 - Bank of Canada' },
    { value: '219', text: '219 - ATB Financial' },
    { value: '241', text: '241 - Bank of America, National Association' },
    { value: '242', text: '242 - The Bank of New York Mellon' },
    { value: '245', text: '245 - MUFG Bank, Ltd., Canada Branch' },
    { value: '250', text: '250 - BNP Paribas' },
    { value: '260', text: '260 - Citibank Canada' },
    { value: '265', text: '265 - Deutsche Bank AG' },
    { value: '269', text: '269 - Mega International Commercial Bank Co., Ltd.' },
    { value: '270', text: '270 - JPMorgan Chase Bank, National Association' },
    { value: '275', text: '275 - KEB Hana Bank Canada' },
    { value: '277', text: '277 - Mizuho Bank Ltd.' },
    { value: '290', text: '290 - UBS Bank (Canada)' },
    { value: '294', text: '294 - SBI Canada Bank' },
    { value: '301', text: '301 - Sumitomo Mitsui Banking Corporation, Canada Branch' },
    { value: '303', text: '303 - Amex Bank of Canada' },
    { value: '307', text: '307 - Industrial and Commercial Bank of China (Canada)' },
    { value: '308', text: '308 - Bank of China (Canada)' },
    { value: '309', text: '309 - Vancity Community Investment Bank' },
    { value: '310', text: '310 - First Nations Bank of Canada' },
    { value: '314', text: '314 - J.P. Morgan Bank Canada' },
    { value: '315', text: '315 - CTBC Bank Corp. (Canada)' },
    { value: '318', text: '318 - U.S. Bank National Association' },
    { value: '320', text: "320 - President's Choice Bank" },
    { value: '321', text: '321 - Habib Canadian Bank' },
    { value: '322', text: '322 - Rabobank Canada' },
    { value: '323', text: '323 - Capital One Bank (Canada Branch)' },
    { value: '326', text: '326 - Canadian Imperial Bank of Commerce' },
    { value: '327', text: '327 - State Street' },
    { value: '328', text: '328 - Citibank, N.A' },
    { value: '330', text: '330 - Comerica Bank' },
    { value: '332', text: '332 - First Commercial Bank' },
    { value: '334', text: '334 - VersaBank' },
    { value: '335', text: '335 - United Overseas Bank Limited' },
    { value: '338', text: '338 - Canadian Tire Bank' },
    { value: '340', text: '340 - ICICI Bank Canada' },
    { value: '343', text: '343 - ADS Canadian Bank' },
    { value: '344', text: '344 - General Bank of Canada' },
    { value: '346', text: '346 - Société Générale (Canada Branch)' },
    { value: '347', text: '347 - Bridgewater Bank' },
    { value: '349', text: '349 - The Northern Trust Company, Canada Branch' },
    { value: '352', text: '352 - Digital Commerce Bank' },
    { value: '355', text: '355 - Shinhan Bank Canada' },
    { value: '356', text: '356 - Citco Bank Canada' },
    { value: '357', text: '357 - M & T Bank' },
    { value: '358', text: '358 - HomeEquity Bank' },
    { value: '359', text: '359 - Duo Bank of Canada' },
    { value: '360', text: '360 - Barclays Bank PLC, Canada Branch' },
    { value: '361', text: '361 - Home Bank' },
    { value: '362', text: '362 - Wells Fargo Bank, National Association, Canadian Branch' },
    { value: '365', text: '365 - PNC Bank Canada Branch' },
    { value: '366', text: '366 - China Construction Bank Toronto Branch' },
    { value: '368', text: '368 - Rogers Bank' },
    { value: '370', text: '370 - Wealth One Bank of Canada' },
    { value: '372', text: '372 - Bank of China, Toronto Branch' },
    { value: '374', text: '374 - Motus Bank' },
    { value: '376', text: '376 - Exchange Bank of Canada' },
    { value: '377', text: '377 - RFA Bank of Canada' },
    { value: '378', text: '378 - Cidel Bank Canada' },
    { value: '381', text: '381 - Haventree Bank' },
    { value: '382', text: '382 - Coast Capital Savings Federal Credit Union' },
    { value: '383', text: '383 - Peoples Bank of Canada' },
    { value: '507', text: '507 - Community Trust Company' },
    { value: '509', text: '509 - The Canada Trust Company' },
    { value: '522', text: '522 - Trust La Laurentienne du Canada Inc.' },
    { value: '532', text: '532 - Effort Trust Company' },
    { value: '536', text: '536 - Investors Group Trust Co. Ltd.' },
    { value: '540', text: '540 - Manulife Bank of Canada' },
    { value: '548', text: '548 - CIBC Trust Corporation' },
    { value: '550', text: '550 - Montreal Trust Company of Canada' },
    { value: '551', text: '551 - Sun Life Financial Trust Inc.' },
    { value: '568', text: '568 - Peace Hills Trust Company' },
    { value: '570', text: '570 - The Royal Trust Company' },
    { value: '580', text: '580 - Royal Trust Corporation of Canada' },
    { value: '590', text: '590 - National Trust Company' },
    { value: '597', text: '597 - TD Mortgage Corporation' },
    { value: '603', text: '603 - TD Pacific Mortgage Corporation' },
    { value: '604', text: '604 - HSBC Mortgage Corporation (Canada)' },
    { value: '606', text: '606 - Scotia Mortgage Corporation' },
    { value: '608', text: '608 - CS Alterna Bank' },
    { value: '612', text: '612 - Natcan Trust Company' },
    { value: '614', text: '614 - Tangerine Bank' },
    { value: '618', text: '618 - B2B Bank' },
    { value: '621', text: '621 - Peoples Trust Company' },
    { value: '623', text: '623 - Equitable Bank' },
    { value: '626', text: '626 - Manulife Trust Company' },
    { value: '627', text: '627 - Home Trust Company' },
    { value: '701', text: '701 - Edward Jones' },
    { value: '702', text: '702 - Manufacturers Life Insurance Company' },
    { value: '703', text: '703 - Wealthsimple Investments Inc.' },
    { value: '809', text: '809 - Central 1 Credit Union' },
    { value: '815', text: '815 - Fédération des caisses Desjardins du Quebec' },
    { value: '819', text: '819 - Caisse Populaire Group Financier Ltée' },
    { value: '828', text: '828 - Central 1 Credit Union' },
    { value: '829', text: '829 - Caisse Desjardins Ontario Credit Union Inc.' },
    { value: '837', text: '837 - Meridian Credit Union (formerly Hepco)' },
    { value: '839', text: '839 - Atlantic Central' },
    { value: '849', text: '849 - Atlantic Central' },
    { value: '853', text: '853 - Concentra Bank' },
    { value: '865', text: '865 - Caisse populaire acadienne ltée' },
    { value: '869', text: '869 - Central 1 Credit Union' },
    { value: '879', text: '879 - Credit Union Central of Manitoba Limited' },
    { value: '889', text: '889 - Credit Union Central of Saskatchewan' },
    { value: '899', text: '899 - Credit Union Central Alberta' },
    { value: '890', text: '890 - Caisse populaire Alliance Limitée' },
    { value: '899', text: '899 - Credit Union Central Alberta Limited' }
];

const currencyIds = {
    EUR: 0,
    CAD: 1,
    CHF: 2,
    USD: 3,
    GBP: 4
};

function BankFormTicketPro({ organization }) {
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        const url = `https://form.typeform.com/to/BwHt9ggS?typeform-source=weezevent.atlassian.net&organization_id=${organization.id}`;
        window.open(url, '_blank');
    }, [organization]);

    return (
        <Card.FormStep
            title={t('ticket.organiser.banking.title')}
            rightComponent={
                <Message type="tips" title={t('ticket.organiser.description.tips')} mini>
                    <Trans i18nKey="ticket.organiser.banking.ticketpro-tips" />
                </Message>
            }
        >
            <>
                <div>{t('ticket.organiser.banking.ticketpro-description')}</div>
                <div className={Style['ticketpro-cta']}>
                    <Button primary label={t('ticket.organiser.banking.ticketpro-cta')} onClick={handleClick} />
                </div>
            </>
        </Card.FormStep>
    );
}

function BankForm({ organization, bank, formBank, setFormBank, bankErrors }) {
    const { t } = useTranslation();
    const history = useHistory();
    const toast = React.useContext(ToastContext);
    const [preview, setPreview] = React.useState(false);

    const displayMessage = React.useMemo(() => {
        return (
            !organization.name ||
            !organization.organization_type ||
            !organization.last_name ||
            !organization.first_name ||
            !organization.address?.address1 ||
            !organization.address?.zip_code ||
            !organization.address?.city ||
            !organization.address?.country ||
            !organization.phone_number
        );
    }, [organization]);

    const sendMail = React.useCallback(() => {
        organization
            .resend_bank_mail()
            .then(({ response }) => {
                toast.success(t('ticket.organiser.banking.sendMailSuccess'));
            })
            .catch(error => {
                toast.error(t('ticket.organiser.banking.sendMailError'));
            });
    }, [organization]);

    return (
        <>
            {displayMessage && (
                <MessageInformation
                    organization={organization}
                    links={{
                        label: t('ticket.organiser.message.action_profile_label'),
                        onClick: () => {
                            history.push(`/ticket/O${organization.id}/organization/profile`);
                        }
                    }}
                />
            )}
            {(bank.iban || bank.rbc_account) && !Number(bank.valid) && <MessageValidationBank sendMail={sendMail} />}
            <Card.FormStep
                title={t('ticket.organiser.banking.title')}
                rightComponent={
                    <Message type="tips" title={t('ticket.organiser.description.tips')} mini>
                        <Trans i18nKey="ticket.organiser.banking.tips" />
                    </Message>
                }
            >
                <LoadingCard loading={!organization}>
                    {organization.currency !== 'CAD' && organization.currency !== 'USD' ? (
                        <>
                            <Form.Field>
                                <Form.Label label={t('ticket.organiser.banking.name')} />
                                <Form.Input
                                    onChange={event => setFormBank('titulaire', event.target.value)}
                                    placeholder={t('ticket.organiser.banking.name_placeholder')}
                                    value={formBank.titulaire}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label>
                                    {t('ticket.organiser.banking.iban')}
                                    <TooltipHelp title={t('ticket.organiser.banking.iban_tooltip')} />
                                </Form.Label>
                                <Form.Input
                                    onChange={event => setFormBank('iban', event.target.value.replace(/\s/g, ''))}
                                    placeholder="FR1420041010050500013M02606"
                                    value={formBank.iban}
                                    errors={bankErrors['iban'] === 'invalid' && true}
                                />
                                <Form.FieldErrors errors={[bankErrors['iban'] === 'invalid' && t(bankErrors['iban'])]} />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label>
                                    {t('ticket.organiser.banking.bic')}
                                    <TooltipHelp title={t('ticket.organiser.banking.bic_tooltip')} />
                                </Form.Label>
                                <Form.Input
                                    onChange={event => setFormBank('bic_swift', event.target.value.replace(/\s/g, ''))}
                                    placeholder="CRAFFTPR"
                                    value={formBank.bic_swift}
                                    errors={bankErrors['bic_swift'] === 'invalid' && true}
                                />
                                <Form.FieldErrors errors={[bankErrors['bic_swift'] === 'invalid' && t(bankErrors['bic_swift'])]} />
                            </Form.Field>
                        </>
                    ) : (
                        <>
                            <Form.Field>
                                <Form.Label label={t('ticket.organiser.banking.rbc_succursale')} />
                                <Form.Input
                                    maxLength="5"
                                    onChange={event => setFormBank('rbc_succursale', event.target.value)}
                                    placeholder="00000"
                                    value={formBank.rbc_succursale}
                                />
                                <Form.FieldErrors errors={[bankErrors['rbc_succursale'] === 'invalid' && t(bankErrors['rbc_succursale'])]} />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label label={t('ticket.organiser.banking.rbc_institute')} />
                                <Select
                                    clearable
                                    placeholder={t('ticket.common.action.select')}
                                    style={{ width: '100%' }}
                                    search
                                    options={institutionsCanadian}
                                    onChange={(synth, { value }) => {
                                        setFormBank('rbc_institute', value);
                                    }}
                                    value={formBank.rbc_institute}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label>{t('ticket.organiser.banking.name')}</Form.Label>
                                <Form.Input
                                    onChange={event => setFormBank('titulaire', event.target.value)}
                                    placeholder={t('ticket.organiser.banking.name_placeholder')}
                                    value={formBank.titulaire}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Label>
                                    {t('ticket.organiser.banking.rbc_account')}
                                    <TooltipHelp title={t('ticket.organiser.banking.rbc_account_tooltip')} />
                                </Form.Label>
                                <Form.Input maxLength="24" onChange={event => setFormBank('rbc_account', event.target.value.replace(/\D/, ''))} value={formBank.rbc_account} />
                                <Form.FieldErrors errors={[bankErrors['rbc_account'] === 'invalid' && t(bankErrors['rbc_account'])]} />
                            </Form.Field>
                            <span onClick={() => setPreview(!preview)} className={Style['link-preview']}>
                                <Icon className={Style['link-preview__icon']} name="eye" size="small" />
                                {t('ticket.organiser.banking.find_information')}
                            </span>
                            {preview && (
                                <Form.Field className={Style['overview']}>
                                    <img src={ImgChequeCAD} alt="cheque CAD" />
                                </Form.Field>
                            )}
                        </>
                    )}
                </LoadingCard>
            </Card.FormStep>
            <SwornStatement formOrganisation={formBank} onChange={setFormBank} />
        </>
    );
}
export default function Bank({ organization, bank, setBank }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const validateSworn = React.useCallback((name, sworn, form) => {
        if (!sworn) {
            return t('ticket.common.required');
        }
        return true;
    }, []);

    const currencyId = React.useMemo(() => {
        let symbol = organization.currency;

        return currencyIds[symbol] !== undefined ? currencyIds[symbol] : null;
    }, [organization]);

    const validators = React.useMemo(() => {
        return {
            titulaire: requiredField,
            sworn: validateSworn,
            bic_swift: {
                conditionals: {
                    currency: [new Conditional('different', 'ticket.common.required', ['CAD', 'USD']), requiredField]
                }
            },
            iban: {
                conditionals: {
                    currency: [new Conditional('different', 'ticket.common.required', ['CAD', 'USD']), requiredField]
                }
            },
            rbc_succursale: {
                conditionals: {
                    currency: [new Conditional('equals', 'ticket.common.required', ['CAD', 'USD']), requiredField]
                }
            },
            rbc_institute: {
                conditionals: {
                    currency: [new Conditional('equals', 'ticket.common.required', ['CAD', 'USD']), requiredField]
                }
            },
            rbc_account: {
                conditionals: {
                    currency: [new Conditional('equals', 'ticket.common.required', ['CAD', 'USD']), requiredField]
                }
            }
        };
    }, [validateSworn]);

    const [formBank, setFormBank, setFormBankObject, bankErrors, bankValidate, setBankErrors] = useForm(
        {
            currency: organization.currency,
            titulaire: '',
            bic_swift: '',
            iban: '',
            rbc_succursale: '',
            rbc_institute: '',
            rbc_account: '',
            sworn: false
        },
        validators
    );

    React.useEffect(() => {
        bankValidate();
    }, [formBank]);

    React.useEffect(() => {
        const { titulaire = '', bic_swift = '', iban = '', rbc_succursale = '', rbc_institute = '', rbc_account = '' } = bank;
        setFormBankObject({ titulaire, bic_swift, iban, rbc_succursale: rbc_succursale.padStart(5, '0'), rbc_institute, rbc_account }, true);
    }, [bank]);

    const handleSubmit = React.useCallback(() => {
        if (!bankValidate()) {
            return;
        }
        const { titulaire, bic_swift, iban, rbc_succursale, rbc_institute, rbc_account } = formBank;

        const bank = new BankModel({
            id: organization.id,
            id_organisateur: organization.id,
            titulaire,
            bic_swift,
            iban,
            rbc_succursale,
            rbc_institute,
            rbc_account,
            currency_id: currencyId
        });

        bank.save({
            organizationId: organization.id
        })
            .then(({ response }) => {
                setBank(response);
                toast.success(t(`ticket.organiser.banking.saveSuccess`));
            })
            .catch(error => {
                setBankErrors(error.response);
                toast.error(t(`ticket.organiser.banking.saveError`));
            })
            .finally(() => {
                setFormBank('sworn', false);
            });
    }, [formBank, bankValidate, currencyId, organization]);

    return (
        <>
            <WeezHeader
                title={t(`ticket.organiser.banking.pageTitle`)}
                rightComponent={
                    !organization.isBrandTicketPro()
                        ? [<Button primary key="primary" label={t('ticket.common.action.save')} onClick={handleSubmit} disabled={Object.entries(bankErrors).length > 0} />]
                        : undefined
                }
            >
                {t('ticket.organiser.banking.subTitle')}
            </WeezHeader>
            {organization.isBrandTicketPro() ? (
                <BankFormTicketPro organization={organization} />
            ) : (
                <BankForm organization={organization} bank={bank} formBank={formBank} bankErrors={bankErrors} setFormBank={setFormBank} />
            )}
        </>
    );
}

Bank.propTypes = {
    organization: PropTypes.object.isRequired,
    bank: PropTypes.object.isRequired,
    setBank: PropTypes.func.isRequired
};
